import Cookies from 'js-cookie';
import { AccountFieldSetConfig } from '../components/Account/types';
import { MarketingData, RegistrationFieldConfig, RegistrationFieldSetConfig } from '../components/Registration/types';
import { btag } from '../consts';
import { FlattenedProfileData } from '../hooks/registration';
import { getExternalUrlParam } from './links-helper/links-helper';

type FieldType = RegistrationFieldConfig & { name: string };
type FieldSetType = RegistrationFieldSetConfig | AccountFieldSetConfig<FlattenedProfileData>;

export const getMarketingPreferences = (
  marketingObject: MarketingData,
  fieldSets: FieldSetType[]
): (FieldSetType & {
  fields: FieldType[];
})[] =>
  fieldSets.map((fieldSet) => {
    const { fields, ...otherData } = fieldSet;
    const newFields = (fields as FieldType[]).map((marketingPreferenceName) => {
      const marketingValue =
        marketingObject[
          marketingPreferenceName.name as
            | 'optInEmail'
            | 'optInSms'
            | 'optInTelephone'
            | 'optInEmailCasino'
            | 'optInSmsCasino'
            | 'optInTelephoneCasino'
            | 'optInEmailBingo'
            | 'optInSmsBingo'
            | 'optInTelephoneBingo'
        ];

      return {
        ...marketingPreferenceName,
        hidden: marketingValue === undefined ? false : !marketingValue,
      };
    });

    return {
      ...otherData,
      fields: newFields,
    };
  });

export const handleMarketingCookie = (): void => {
  // Extract and store UTM parameters
  const utmParams = [btag, 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmParams.forEach((param) => {
    const value = getExternalUrlParam(param);

    if (value) {
      // Store in cookie with 60 days expiry
      Cookies.set(param, value, { expires: 60 });
    }
  });
};
